import React, { useState, useEffect } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
// import Grid from '@material-ui/core/Grid'; // ✅ REMOVIDO: No se usa
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

// Icons
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import FilterListIcon from '@material-ui/icons/FilterList';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import ScheduleIcon from '@material-ui/icons/Schedule';
import NotesIcon from '@material-ui/icons/Notes';

// Components
import MainContainer from '../../components/MainContainer';
import MainHeader from '../../components/MainHeader';
import MainHeaderButtonsWrapper from '../../components/MainHeaderButtonsWrapper';
import Title from '../../components/Title';

const useStyles = makeStyles((theme) => ({
  // ✅ ESTILOS PRINCIPALES
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  
  // ✅ CORREGIDO: FormContainer dinámico según tema
  formContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
  },
  
  formRow: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'flex-end',
  },
  
  formField: {
    flex: 1,
  },
  
  priorityField: {
    minWidth: 150,
  },
  
  categoryField: {
    minWidth: 150,
  },
  
  // ✅ CORREGIDO: TaskCard dinámico según tema
  taskCard: {
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)',
    },
  },
  
  // ✅ CORREGIDO: CompletedTask dinámico según tema
  completedTask: {
    opacity: 0.7,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
  },
  
  taskContent: {
    paddingBottom: theme.spacing(1),
  },
  
  // ✅ CORREGIDO: TaskTitle dinámico según tema
  taskTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  
  taskMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  
  taskActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
  
  // ✅ ESTILOS PARA CHIPS DE PRIORIDAD
  priorityHigh: {
    backgroundColor: '#e74c3c',
    color: 'white',
    fontWeight: 'bold',
  },
  
  priorityMedium: {
    backgroundColor: '#f39c12',
    color: 'white',
    fontWeight: 'bold',
  },
  
  priorityLow: {
    backgroundColor: '#27ae60',
    color: 'white',
    fontWeight: 'bold',
  },
  
  // ✅ ESTILOS PARA CHIPS DE ESTADO
  statusPending: {
    backgroundColor: '#6c757d',
    color: 'white',
  },
  
  statusCompleted: {
    backgroundColor: '#28a745',
    color: 'white',
  },
  
  // ✅ CORREGIDO: FilterContainer dinámico según tema
  filterContainer: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
  },
  
  filterRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  
  // ✅ ESTILOS PARA ESTADÍSTICAS
  statsContainer: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  
  // ✅ CORREGIDO: StatCard dinámico según tema
  statCard: {
    flex: 1,
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
    boxShadow: theme.mode === 'dark' ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
  },
  
  // ✅ CORREGIDO: StatNumber dinámico según tema
  statNumber: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  
  // ✅ CORREGIDO: StatLabel dinámico según tema
  statLabel: {
    fontSize: '0.875rem',
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginTop: theme.spacing(0.5),
  },
  
  // ✅ CORREGIDO: TasksContainer dinámico según tema
  tasksContainer: {
    maxHeight: 'calc(100vh - 400px)', // Altura máxima calculada
    overflowY: 'auto',
    paddingRight: theme.spacing(1),
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.mode === 'dark' ? '#374151' : '#f1f1f1',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.mode === 'dark' ? '#6B7280' : '#c1c1c1',
      borderRadius: '4px',
      '&:hover': {
        background: theme.mode === 'dark' ? '#9CA3AF' : '#a8a8a8',
      },
    },
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      '&.Mui-focused': {
        backgroundColor: theme.mode === 'dark' ? '#374151' : 'white',
        boxShadow: `0 0 0 2px ${theme.mode === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(25, 118, 210, 0.2)'}`,
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: theme.palette.primary.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
  // ✅ CORREGIDO: FormControl dinámico según tema
  formControl: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#eeeeee',
      },
      "& fieldset": {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
      },
    },
    "& .MuiInputLabel-root": {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      "&.Mui-focused": {
        color: theme.palette.primary.main,
      },
    },
    "& .MuiSelect-root": {
      color: theme.palette.text.primary,
    },
    "& .MuiMenuItem-root": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      },
    },
  },
}));

const ToDoList = () => {
  const classes = useStyles();
  const theme = useTheme();

  // ✅ ESTADOS PRINCIPALES
  const [task, setTask] = useState('');
  const [priority, setPriority] = useState('medium');
  const [category, setCategory] = useState('general');
  const [tasks, setTasks] = useState([]);
  const [editIndex, setEditIndex] = useState(-1);
  
  // ✅ ESTADOS PARA FILTROS
  const [searchTerm, setSearchTerm] = useState('');
  const [filterPriority, setFilterPriority] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  // ✅ CATEGORÍAS DISPONIBLES
  const categories = [
    { value: 'general', label: 'General' },
    { value: 'urgent', label: 'Urgente' },
    { value: 'followup', label: 'Seguimiento' },
    { value: 'meeting', label: 'Reunión' },
    { value: 'system', label: 'Sistema' },
    { value: 'customer', label: 'Cliente' },
  ];

  // ✅ CARGAR TAREAS DESDE LOCALSTORAGE
  useEffect(() => {
    const savedTasks = localStorage.getItem('todolist-tasks');
    if (savedTasks) {
      try {
        const parsedTasks = JSON.parse(savedTasks);
        // Convertir fechas de string a Date
        const tasksWithDates = parsedTasks.map(task => ({
          ...task,
          createdAt: new Date(task.createdAt),
          updatedAt: new Date(task.updatedAt),
        }));
        setTasks(tasksWithDates);
      } catch (error) {
        console.error('Error parsing saved tasks:', error);
        setTasks([]);
      }
    }
  }, []);

  // ✅ GUARDAR TAREAS EN LOCALSTORAGE
  useEffect(() => {
    localStorage.setItem('todolist-tasks', JSON.stringify(tasks));
  }, [tasks]);

  // ✅ MANEJAR CAMBIOS EN EL FORMULARIO
  const handleTaskChange = (event) => {
    setTask(event.target.value);
  };

  const handlePriorityChange = (event) => {
    setPriority(event.target.value);
  };

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };

  // ✅ AGREGAR/EDITAR TAREA
  const handleAddTask = () => {
    if (!task.trim()) {
      return;
    }

    const now = new Date();
    if (editIndex >= 0) {
      // Editar tarea existente
      const newTasks = [...tasks];
      newTasks[editIndex] = {
        text: task,
        priority,
        category,
        status: newTasks[editIndex].status,
        updatedAt: now,
        createdAt: newTasks[editIndex].createdAt,
      };
      setTasks(newTasks);
      resetForm();
    } else {
      // Agregar nueva tarea
      const newTask = {
        id: Date.now(),
        text: task,
        priority,
        category,
        status: 'pending',
        createdAt: now,
        updatedAt: now,
      };
      setTasks([newTask, ...tasks]);
      resetForm();
    }
  };

  // ✅ RESETEAR FORMULARIO
  const resetForm = () => {
    setTask('');
    setPriority('medium');
    setCategory('general');
    setEditIndex(-1);
  };

  // ✅ EDITAR TAREA
  const handleEditTask = (index) => {
    const taskToEdit = tasks[index];
    setTask(taskToEdit.text);
    setPriority(taskToEdit.priority);
    setCategory(taskToEdit.category);
    setEditIndex(index);
  };

  // ✅ ELIMINAR TAREA
  const handleDeleteTask = (index) => {
    const newTasks = [...tasks];
    newTasks.splice(index, 1);
    setTasks(newTasks);
  };

  // ✅ CAMBIAR ESTADO DE TAREA
  const handleToggleStatus = (index) => {
    const newTasks = [...tasks];
    newTasks[index].status = newTasks[index].status === 'pending' ? 'completed' : 'pending';
    newTasks[index].updatedAt = new Date();
    setTasks(newTasks);
  };

  // ✅ FILTRAR TAREAS
  const filteredTasks = tasks.filter(task => {
    const matchesSearch = task.text.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesPriority = filterPriority === 'all' || task.priority === filterPriority;
    const matchesStatus = filterStatus === 'all' || task.status === filterStatus;
    
    return matchesSearch && matchesPriority && matchesStatus;
  });

  // ✅ CALCULAR ESTADÍSTICAS
  const stats = {
    total: tasks.length,
    pending: tasks.filter(t => t.status === 'pending').length,
    completed: tasks.filter(t => t.status === 'completed').length,
    urgent: tasks.filter(t => t.priority === 'high').length,
  };

  // ✅ OBTENER ESTILO DE PRIORIDAD
  const getPriorityStyle = (priority) => {
    switch (priority) {
      case 'high': return classes.priorityHigh;
      case 'medium': return classes.priorityMedium;
      case 'low': return classes.priorityLow;
      default: return classes.priorityMedium;
    }
  };

  // ✅ OBTENER ESTILO DE ESTADO
  const getStatusStyle = (status) => {
    return status === 'completed' ? classes.statusCompleted : classes.statusPending;
  };

  // ✅ OBTENER LABEL DE PRIORIDAD
  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'high': return 'Alta';
      case 'medium': return 'Media';
      case 'low': return 'Baja';
      default: return 'Media';
    }
  };

  // ✅ OBTENER LABEL DE CATEGORÍA
  const getCategoryLabel = (category) => {
    const cat = categories.find(c => c.value === category);
    return cat ? cat.label : 'General';
  };

  return (
    <MainContainer>
      <MainHeader>
        <Title>
          <Box display="flex" alignItems="center">
            <NotesIcon style={{ marginRight: 8 }} />
            Anotaciones del Operador
          </Box>
        </Title>
        <MainHeaderButtonsWrapper>
          <TextField
            placeholder="Buscar tareas..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: theme.palette.text.secondary || "gray" }} />
                </InputAdornment>
              ),
            }}
            className={classes.textField}
            style={{ marginRight: 16 }}
          />
        </MainHeaderButtonsWrapper>
      </MainHeader>

      {/* ✅ ESTADÍSTICAS */}
      <div className={classes.statsContainer}>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.total}</div>
          <div className={classes.statLabel}>Total</div>
        </div>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.pending}</div>
          <div className={classes.statLabel}>Pendientes</div>
        </div>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.completed}</div>
          <div className={classes.statLabel}>Completadas</div>
        </div>
        <div className={classes.statCard}>
          <div className={classes.statNumber}>{stats.urgent}</div>
          <div className={classes.statLabel}>Urgentes</div>
        </div>
      </div>

      {/* ✅ FORMULARIO DE NUEVA TAREA */}
      <Paper className={classes.formContainer}>
        <Typography variant="h6" gutterBottom style={{ color: theme.palette.text.primary }}>
          {editIndex >= 0 ? 'Editar Tarea' : 'Nueva Tarea'}
        </Typography>
        
        <div className={classes.formRow}>
          <TextField
            className={`${classes.formField} ${classes.textField}`}
            label="Descripción de la tarea"
            value={task}
            onChange={handleTaskChange}
            variant="outlined"
            placeholder="Ej: Revisar configuración del servidor..."
            multiline
            rows={2}
          />
        </div>
        
        <div className={classes.formRow}>
          <FormControl className={`${classes.priorityField} ${classes.formControl}`} variant="outlined">
            <InputLabel>Prioridad</InputLabel>
            <Select
              value={priority}
              onChange={handlePriorityChange}
              label="Prioridad"
            >
              <MenuItem value="low">Baja</MenuItem>
              <MenuItem value="medium">Media</MenuItem>
              <MenuItem value="high">Alta</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl className={`${classes.categoryField} ${classes.formControl}`} variant="outlined">
            <InputLabel>Categoría</InputLabel>
            <Select
              value={category}
              onChange={handleCategoryChange}
              label="Categoría"
            >
              {categories.map(cat => (
                <MenuItem key={cat.value} value={cat.value}>
                  {cat.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddTask}
            startIcon={<AddIcon />}
            disabled={!task.trim()}
          >
            {editIndex >= 0 ? 'Guardar Cambios' : 'Agregar Tarea'}
          </Button>
          
          {editIndex >= 0 && (
            <Button
              variant="outlined"
              onClick={resetForm}
            >
              Cancelar
            </Button>
          )}
        </div>
      </Paper>

      {/* ✅ FILTROS */}
      <Paper className={classes.filterContainer}>
        <Typography variant="subtitle1" gutterBottom style={{ color: theme.palette.text.primary }}>
          <FilterListIcon style={{ marginRight: 8, verticalAlign: 'middle', color: theme.palette.text.primary }} />
          Filtros
        </Typography>
        <div className={classes.filterRow}>
          <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 150 }}>
            <InputLabel>Prioridad</InputLabel>
            <Select
              value={filterPriority}
              onChange={(e) => setFilterPriority(e.target.value)}
              label="Prioridad"
            >
              <MenuItem value="all">Todas</MenuItem>
              <MenuItem value="high">Alta</MenuItem>
              <MenuItem value="medium">Media</MenuItem>
              <MenuItem value="low">Baja</MenuItem>
            </Select>
          </FormControl>
          
          <FormControl variant="outlined" className={classes.formControl} style={{ minWidth: 150 }}>
            <InputLabel>Estado</InputLabel>
            <Select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              label="Estado"
            >
              <MenuItem value="all">Todos</MenuItem>
              <MenuItem value="pending">Pendientes</MenuItem>
              <MenuItem value="completed">Completadas</MenuItem>
            </Select>
          </FormControl>
        </div>
      </Paper>

      {/* ✅ LISTA DE TAREAS CON SCROLL */}
      <div className={classes.tasksContainer}>
        {filteredTasks.length === 0 ? (
          <Paper style={{ 
            padding: 32, 
            textAlign: 'center', 
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
          }}>
            <Typography variant="h6" style={{ color: theme.palette.text.primary }}>
              {tasks.length === 0 ? 'No hay tareas creadas' : 'No se encontraron tareas con los filtros aplicados'}
            </Typography>
            <Typography variant="body2" style={{ marginTop: 8, color: theme.palette.text.secondary || theme.palette.text.primary }}>
              {tasks.length === 0 ? 'Crea tu primera tarea usando el formulario de arriba' : 'Ajusta los filtros para ver más tareas'}
            </Typography>
          </Paper>
        ) : (
          filteredTasks.map((task, index) => (
            <Card
              key={task.id || index}
              className={`${classes.taskCard} ${task.status === 'completed' ? classes.completedTask : ''}`}
            >
              <CardContent className={classes.taskContent}>
                <Typography className={classes.taskTitle} variant="h6">
                  {task.text}
                </Typography>
                
                <div className={classes.taskMeta}>
                  <Chip
                    label={getPriorityLabel(task.priority)}
                    className={getPriorityStyle(task.priority)}
                    size="small"
                    icon={<PriorityHighIcon />}
                  />
                  
                  <Chip
                    label={getCategoryLabel(task.category)}
                    variant="outlined"
                    size="small"
                  />
                  
                  <Chip
                    label={task.status === 'completed' ? 'Completada' : 'Pendiente'}
                    className={getStatusStyle(task.status)}
                    size="small"
                    icon={task.status === 'completed' ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
                  />
                  
                  <Box display="flex" alignItems="center" style={{ marginLeft: 'auto' }}>
                    <ScheduleIcon style={{ fontSize: 16, marginRight: 4, color: theme.palette.text.secondary || '#6c757d' }} />
                    <Typography variant="caption" style={{ color: theme.palette.text.secondary || theme.palette.text.primary }}>
                      {task.updatedAt.toLocaleDateString()} {task.updatedAt.toLocaleTimeString()}
                    </Typography>
                  </Box>
                </div>
              </CardContent>
              
              <CardActions className={classes.taskActions}>
                <IconButton
                  onClick={() => handleToggleStatus(index)}
                  color={task.status === 'completed' ? 'default' : 'primary'}
                  title={task.status === 'completed' ? 'Marcar como pendiente' : 'Marcar como completada'}
                >
                  {task.status === 'completed' ? <RadioButtonUncheckedIcon /> : <CheckCircleIcon />}
                </IconButton>
                
                <IconButton
                  onClick={() => handleEditTask(index)}
                  color="primary"
                  title="Editar tarea"
                >
                  <EditIcon />
                </IconButton>
                
                <IconButton
                  onClick={() => handleDeleteTask(index)}
                  color="secondary"
                  title="Eliminar tarea"
                >
                  <DeleteIcon />
                </IconButton>
              </CardActions>
            </Card>
          ))
        )}
      </div>
    </MainContainer>
  );
};


export default ToDoList;
